import type { User } from '../types/commons';

export type Level = 'info' | 'warning' | 'error';

// Extra data attached to the notifier event (e.g. Sentry `extra`); keep it out of the Error message so grouping is unaffected.
export type ErrorContext = Record<string, unknown>;

export type ErrorNotifier = {
  notify: (error: Error, level?: Level, context?: ErrorContext) => void;
  setUser: (user: User | null) => void;
};

const errorNotifiers: ErrorNotifier[] = [];

export const registerErrorNotifier = (errorNotifier: ErrorNotifier) => {
  errorNotifiers.push(errorNotifier);
};

export const errorNotifier: ErrorNotifier = {
  notify: (error: Error, level: Level = 'error', context?: ErrorContext) => {
    errorNotifiers.map((notifier) => notifier.notify(error, level, context));
  },
  setUser: (user) => {
    errorNotifiers.map((u) => u.setUser(user));
  },
};
